import styled from 'styled-components';

export const StyledControls = styled.div`
    display: flex;
    justify-content: flex-end;
    border-bottom: 1px solid rgba(0, 0, 0, 0.14);
    margin-bottom: 40px;
    padding-bottom: 10px;
    svg {
        fill: rgba(0, 0, 0, 0.45);
    }
`;
